import { Component, input, output } from '@angular/core';
import { ParseRequestState } from '../../stores/parse-requests.store';
import {
  Button,
  LoadingSpinner,
  Badge,
  PopoverComponent,
  PopoverDirective,
  DropdownPopoverLayout,
  DropdownOption,
} from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-parse-requests-active-dropdown',
  imports: [
    Button,
    LoadingSpinner,
    Badge,
    PopoverComponent,
    PopoverDirective,
    TranslocoPipe,
    DatePipe,
    DropdownPopoverLayout,
    DropdownOption,
  ],
  templateUrl: './parse-requests-active-dropdown.html',
})
export class ParseRequestsActiveDropdown {
  activeParseRequests = input.required<ParseRequestState[]>();

  clickParseRequest = output<string>();
}
